import { render, staticRenderFns } from "./EditorGroupModal.vue?vue&type=template&id=13e12039&"
import script from "./EditorGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditorGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports